import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="modal"
export default class extends Controller {
  static targets = ["modal", "submitButton", "option"];

  static values = {
    submitButtonTexts: Array,
    id: String,
  };

  connect() {
    this.bootstrapModal = new bootstrap.Modal(this.modalTarget || this.element);
  }

  show() {
    this.bootstrapModal.show();
  }

  close() {
    this.bootstrapModal.hide();
  }

  isOpen() {
    return this.modalTarget.classList.contains("show");
  }

  closeAfterSubmit(e) {
    if (e.detail.success) {
      this.close();
    }
  }

  // app/views/ats/shared/jobs/_match_options_modal.html.erb
  checkOptions() {
    if (!this.optionTargets) return;

    const hasChecked = this.optionTargets.some((opt) => opt.checked);

    if (!hasChecked) {
      this.submitButtonTarget.disabled = true;
      this.submitButtonTarget.textContent = this.submitButtonTextsValue[0];
    } else {
      this.submitButtonTarget.disabled = false;
      this.submitButtonTarget.textContent = this.submitButtonTextsValue[1];
    }
  }
}
